"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICompLogic__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "mantissa",
                        type: "uint256",
                    },
                ],
                internalType: "struct ICompLogic.Exp",
                name: "marketBorrowIndex",
                type: "tuple",
            },
        ],
        name: "distributeBorrowerComp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "supplier",
                type: "address",
            },
        ],
        name: "distributeSupplierComp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "cTokenModify",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "intraSafeLimitMantissa",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "interSafeLimitMantissa",
                type: "uint256",
            },
        ],
        name: "getHypotheticalSafeLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "blockNumber",
                type: "uint32",
            },
        ],
        name: "initializeMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "supplySpeed",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrowSpeed",
                type: "uint256",
            },
        ],
        name: "setCompSpeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
        ],
        name: "uninitializeMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "mantissa",
                        type: "uint256",
                    },
                ],
                internalType: "struct ICompLogic.Exp",
                name: "marketBorrowIndex",
                type: "tuple",
            },
        ],
        name: "updateCompBorrowIndex",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
        ],
        name: "updateCompSupplyIndex",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class ICompLogic__factory {
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.ICompLogic__factory = ICompLogic__factory;
ICompLogic__factory.abi = _abi;
//# sourceMappingURL=ICompLogic__factory.js.map